"use strict"

angular.module("core")
.service("DepositSlipPrintButtonService", function(
    common, FlashBag, gettextCatalog, $q, ZebraPrinterService, DepositSlipService
) {
    this.downloadPaymentPDF = function(params) {
        return DepositSlipService.post(params).$promise.then(function onSuccess(data) {
            var file_data = data.file_data;
            if (file_data) {
                var file_name = data.file_name;
                common.downloadFile(file_data, file_name, {type: "application/pdf;charset=utf-8;"});
            }
            else {
                FlashBag.preformattedError(gettextCatalog.getString("There is an error while trying to generate the file."));
            }
        });
    }

    this.printReceiptPDF = function(params, forceSelectPrinter) {
        return DepositSlipService.post(params).$promise.then(function onSuccess(data) {
            return ZebraPrinterService.defaultResponseCallback(data, forceSelectPrinter);
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/deposit-slip-print-button/deposit-slip-print-button.service.js
// module id = 416
// module chunks = 0